const GET_BATCH_ASSIGNMENTS = `query GetAssignments($entityIdList: [ID!]!, $entityType: Entity!, $dateStart: String, $dateEnd: String, $districtId: ID!, $schoolId: ID!, $assignmentType: [String], $status: [AssignmentStatus!], $limit: Int) {
    assignments(entityId: $entityIdList, entityType: $entityType, filter: {dateFrom: $dateStart, dateTo: $dateEnd, assignmentType: $assignmentType, status: $status, defaultEntities: [{entityType: DISTRICT, entityId: $districtId},{entityType: SCHOOL, entityId: $schoolId},{entityType: CLASS, entityId: 12345}], limit: $limit}) {
        assignments {
          assignmentId
          assignmentType
          createdAt
          entityId
          entityType
          parentId
          status
          dateFrom
          dateTo
          manifest {
            activityType
            locale
            sequence
            status
            storyId
            activity {
              activityId
              type
              status
              displayStatus
              createdAt
              tags
            }
          }
        }
        entityId
      }
}
`;

export default GET_BATCH_ASSIGNMENTS;
